<template>
    <div>
        <div class="search-block">
            <h2>{{ "App.VAKHaku.Header" | translate }}</h2>
            <div class="input-row">
                <div class="input-group">
                    <label class="input-label full-width" for="searchInput">{{ "App.VAKHaku.SearchDescription" | translate }}</label>
                    <input id="searchInput" class="default search wide-search" type="text" v-model="searchValue" v-on:keyup.enter="getVAKResults" />
                    <button id="searchButton" class="search-button" @click="getVAKResults">{{ "App.VAKHaku.SearchButton" | translate }}</button>
                </div>
            </div>
            <div class="api-failed" v-if="apiCallFailed">
                <p class="error-message">{{ "App.VAKHaku.ApiCallFailed" | translate }}</p>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Vue } from "vue-property-decorator"
    import ApiService from "../services/ApiService"
    import AineModel from "../models/aineModel"

    @Component
    export default class VAKHaku extends Vue {
        searchValue: string = ""
        apiService: ApiService = new ApiService(this.$store.getters.baseHref)

        get apiCallFailed(): boolean {
            return this.$store.getters.vakApiCallFailed
        }

        getVAKResults(): void {
            this.$store.dispatch("setLoading", true)
            this.$store.dispatch("setVAKSearchValue", this.searchValue)
            this.apiService.getVAKResults(this.searchValue).then(response => {
                const results: Array<AineModel> = response
                this.$store.dispatch("setVakSearchResults", results)

                // Jos ollaan substance sivulla, ohjataan käyttäjä hakusivulle, jossa hakutulokset näytetään
                if (this.$router.currentRoute.fullPath.includes("VAKAine") && !this.checkIfOnlyOneUN(results)) {
                    this.$router.push("/VAKHaku")
                } else {
                    // Jos listalta löytyy vain yhtä samaa ykNroa, niin avataan substancetable suoraan
                    if (this.checkIfOnlyOneUN(results)) {
                        // Open substanceTable
                        this.$router.push({ name: "VAKAine", params: { ykNro: results[0].ykNro } })
                    }
                }
                this.$store.dispatch("setVakApiCallFailed", false)
            }).catch(() => {
                this.$store.dispatch("setVakSearchResults", [])
                this.$store.dispatch("setVakApiCallFailed", true)
            }).finally(() => {
                this.$store.dispatch("setLoading", false)
            })
        }

        checkIfOnlyOneUN(results: Array<AineModel>): boolean {
            const onlyOneUN: Array<string> = []
            if (results.length === 0) {
                return false
            }
            for (let i = 0; i < results.length; i++) {
                if (!onlyOneUN.includes(results[i].ykNro)) {
                    onlyOneUN.push(results[i].ykNro)
                    if (onlyOneUN.length > 1) {
                        return false
                    }
                }
            }
            return true
        }
    }
</script>

<style scoped>
    .search-block {
        width: 100%;
        max-width: 1000px;
        padding: 20px 40px;
        background-color: rgb(242, 244, 248);
        text-align: left;
        border-top: 7px solid rgb(2, 98, 115);
    }

        .search-block .input-row {
            margin-bottom: 15px;
        }

        .search-block .full-width {
            width: 100%;
        }

        .search-block .input-group {
            width: 100%;
        }

        .search-block .wide-search {
            max-width: 600px;
            width: 80%;
        }

        .search-block .search-button {
            height: 50px;
            max-width: 50px;
            width: 20%;
            border-radius: 0 2px 2px 0;
            border: 1px solid #026273;
            background-color: #026273;
            color: white;
        }

    .error-message {
        color: red;
        font-weight: bold;
        margin-top: 15px;
    }
</style>
